import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import {
  GetReasonsRequestModel,
  GetReasonsResultModel,
  WriteReasonRequestModel,
} from '../interfaces/entities/reason';
import { GenericResultModel } from '../interfaces/entities/base';

@Injectable({
  providedIn: 'root',
})
export class ReasonService {
  constructor(private apiService: ApiBaseService) {}

  /**
   * Get reasons by type
   * @param payload GetReasonsRequestModel
   * @returns Promise<GetReasonsResultModel>
   */
  async getReasons(payload: GetReasonsRequestModel): Promise<GetReasonsResultModel> {
    return this.apiService.httpRequest('ReasonsService/GetReasons', payload, true, true);
  }

  /**
   * Write (create or update) a reason
   * @param payload WriteReasonRequestModel
   * @returns Promise<GenericResultModel>
   */
  async writeReason(payload: WriteReasonRequestModel): Promise<GenericResultModel> {
    return this.apiService.httpRequest('ReasonsService/WriteReason', payload, true, true);
  }
}
